import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import nb from "./Images/neobot.gif";
import "./NeoBot_truck.css"; // <-- import CSS

function NeoBot_truck() {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();

  const [allFiles, setAllFiles] = useState([]);
  const [allFolders, setAllFolders] = useState([]);
  const [fileResults, setFileResults] = useState({});
  const [folderResults, setFolderResults] = useState([]);
  const [openedFile, setOpenedFile] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [dataReady, setDataReady] = useState(false); // ? flag when data is fetched

  const folderUrl =
    "https://drive.google.com/drive/folders/13TkSW1ub8hnqPHjnLKLZ6bNg50XmMFHX";

  useEffect(() => {
    if (!userEmail) {
      navigate("/signin");
      return;
    }

    setLoading(true);
    fetch("https://neobot.d-rosa.ai/api/drive_dump", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ folder_url: folderUrl }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setAllFiles(data.files || []);
          setAllFolders(data.folders || []);
          setDataReady(true); // ? mark data as ready
        } else {
          setError(data.error || "Failed to load Drive data");
        }
      })
      .catch((err) => {
        console.error("Drive fetch error:", err);
        setError("Error connecting to server");
      })
      .finally(() => setLoading(false));
  }, [userEmail, navigate]);

const handleSearch = (e) => {
  e.preventDefault();

  const query = e.target.elements.search.value.trim().toLowerCase(); // ? always fresh
  if (!query) return;

  if (!dataReady) {
    setError("Please wait, data is loading...");
    return;
  }

  setError("");
  setFileResults({});
  setFolderResults([]);
  setOpenedFile(null);

  const queryWords = query.split(/\s+/).filter(Boolean);

  const filteredMatches = {};
  allFiles.forEach((f) => {
    const lowerName = f.name.toLowerCase();
    if (queryWords.every((word) => lowerName.includes(word))) {
      const folderPath = f.path.includes("/")
        ? f.path.split("/").slice(0, -1).join("/")
        : "Root";
      if (!filteredMatches[folderPath]) filteredMatches[folderPath] = [];
      filteredMatches[folderPath].push(f);
    }
  });

  const filteredFolders = allFolders.filter((f) => {
    const lowerName = f.name.toLowerCase();
    return queryWords.every((word) => lowerName.includes(word));
  });

  setFileResults(filteredMatches);
  setFolderResults(filteredFolders);

  if (
    Object.keys(filteredMatches).length === 0 &&
    filteredFolders.length === 0
  ) {
    setError("No results found.");
  }
};

  const handleFileClick = (file) => {
    setOpenedFile(file);
  };

return (
  <div>
    <div className="page-container">
<h2 className="page-header">Truck Bodies</h2>
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <p>Signed in as: {userEmail}</p>

      {/* Floating NeoBot icon */}
      <div
        style={{
          position: "fixed",
          top: "15px",
          left: "15px",
          zIndex: 1000,
        }}
      >
        <img src={nb} alt="NeoBot" width="80" height="80" />
      </div>
 


      

<form onSubmit={handleSearch} className="search-form">
  <input
    type="text"
    name="search"
    placeholder="Search folders..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    className="search-input small-input center-placeholder"
  />
  <button
    type="submit"
    className="search-button"
    disabled={!dataReady} // ? only button disabled
  >
    {dataReady ? "Search" : "Loading..."}
  </button>
</form>

      {loading && <p></p>}
      {error && <p className="error-message">{error}</p>}
  </div>
      <div className="results-container">
        {/* Folder matches */}
        {folderResults.length > 0 && (
          <div className="result-section">
            <h3 className="result-title">Matching Folders</h3>
            <ul className="folder-list">
              {folderResults.map((folder) => (
                <li key={folder.id} className="folder-item">
                  {folder.path} / {folder.name}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* File matches */}
        {Object.keys(fileResults).length > 0 && (
          <div className="result-section">
            <h3 className="result-title">Matching Files</h3>
            {Object.entries(fileResults).map(([folderPath, files]) => (
              <div key={folderPath} className="mb-3">
                <h4 className="font-medium">{folderPath}</h4>
                <ul className="file-list">
                  {files.map((file) => (
                    <li
                      key={file.id}
                      className="file-item"
                      onClick={() => handleFileClick(file)}
                    >
                      {file.name}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* File viewer */}
      {openedFile && (
        <div className="file-preview">
          <h3>Preview: {openedFile.name}</h3>
          <iframe
            src={`https://drive.google.com/file/d/${openedFile.id}/preview`}
            className="file-iframe"
            allow="autoplay"
            title="File Preview"
          />
        </div>
      )}
    </div>
  </div>
);
}

export default NeoBot_truck;
